import { render, staticRenderFns } from "./SpecialTutorDetail.vue?vue&type=template&id=72bf5256&scoped=true"
import script from "./SpecialTutorDetail.vue?vue&type=script&lang=js"
export * from "./SpecialTutorDetail.vue?vue&type=script&lang=js"
import style0 from "./SpecialTutorDetail.vue?vue&type=style&index=0&id=72bf5256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf5256",
  null
  
)

export default component.exports